import { PricingFormType, PricingTierFormType } from "./form";

export const buildPricingMutationInput = (formData: PricingFormType) => ({
  pricingTypeId: formData.pricingTypeId || null,
  thresholdTypeId: formData.thresholdTypeId || null,
  minimumPrice: formData.minimumPrice || null,
  unitThreshold: formData.unitThreshold || null,
  annualDiscountPercent: formData.annualDiscountPercent || null,
  monthlyPricePerUnit: formData.monthlyPricePerUnit || null,
  tiers: (formData.tiers ?? []).map(tier => ({
    lowerThreshold: tier.lowerThreshold ?? null,
    monthlyPrice: tier.monthlyPrice ?? null,
  })),
});

export const buildPricingCalculatorInput = (formData: PricingFormType) => ({
  pricingTypeId: formData.pricingTypeId ?? null,
  minimumPrice: formData.minimumPrice ?? null,
  monthlyPricePerUnit: formData.monthlyPricePerUnit ?? null,
  unitThreshold: formData.unitThreshold ?? null,
  tiers: (formData.tiers ?? [])
    .filter(tier => tier.lowerThreshold != null && tier.monthlyPrice != null)
    .map(tier => ({
      lowerThreshold: tier.lowerThreshold as number,
      monthlyPrice: tier.monthlyPrice as number,
    })),
});

export const mapPricingTiersToForm = (
  tiers: Array<{ lowerThreshold?: number | null; monthlyPrice?: number | null }> | null | undefined,
) =>
  (tiers ?? [])
    .slice()
    .sort((left, right) => (left.lowerThreshold ?? 0) - (right.lowerThreshold ?? 0))
    .map(tier => ({
      lowerThreshold: tier.lowerThreshold ?? undefined,
      monthlyPrice: tier.monthlyPrice ?? undefined,
    }));

export const removePricingTier = (
  tiers: PricingTierFormType[],
  index: number,
): PricingTierFormType[] => {
  const removedLowerThreshold = tiers[index]?.lowerThreshold;
  const nextTiers = tiers.filter((_, tierIndex) => tierIndex !== index);

  if (index < tiers.length - 1 && removedLowerThreshold !== undefined) {
    nextTiers[index] = {
      ...nextTiers[index],
      lowerThreshold: removedLowerThreshold,
    };
  }

  return nextTiers;
};

